const InvestorStructureEnum = Object.freeze({
    INDIVIDUAL: 'INDIVIDUAL',
    TRUST: 'TRUST',
    CORPORATE: 'CORPORATE',
    PENSION: 'PENSION'
});

export default InvestorStructureEnum;
